<template>
  <div>
    <div class="top-image-area container-fluid px-0">
      <img src="~assets/top_image.png" class="img-fluid">
    </div>
    <div class="content-area container">

      <div class="operation-btn-area row text-center mb-4">
        <div class="offset-2 offset-lg-4 col-8 col-lg-4 py-4">
          <div class="my-4">
            <h3 class="h6 font-size-1 mb-1">
              <trans-text i18nKey="ui[1][1]"/>
            </h3>
            <router-link tag="button" class="btn w-100 page-btn btn-lg btn-warning" :to="{ name: 'demo-signup', params: {} }" type="button">
              <trans-text i18nKey="ui[1][2]"/>
            </router-link>
          </div>
          <div class="my-4">
            <h3 class="h6 font-size-1 mb-1">
              <trans-text i18nKey="ui[1][3]"/>
            </h3>
            <router-link tag="button" type="button" class="btn w-100 page-btn btn-lg btn-danger" :to="{ name: 'demo-login', params: {} }" >
              <trans-text i18nKey="ui[1][4]"/>
            </router-link>
          </div>
        </div>
      </div>

      <div class="news-area row">
        <div class="offset-lg-2 col-lg-8">
          <h3 class="news-head h5 font-size-1 mb-0 text-center relative">
            <span style="position: relative; z-index: 10"><trans-text i18nKey="ui[1][5]"/></span>
            <hr class="w-100 news-head-bg-line my-0"/>
            <hr class="h-100 news-head-bg-line-center my-0" />
          </h3>
          <ul class="news-content border-top-0 py-2 px-3">
            <li class="list-unstyled text-left">
              <h6 class="font-weight-bold font-size-md-08-down mb-1" ><trans-text i18nKey="ui[1][101]"/></h6>
              <p class="mb-1 font-size-md-07-down">
                <trans-text i18nKey="ui[1][102]"/></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import AppTranslation from 'api/AppTranslation'
  import GuestPageMixin from 'mixins/GuestPageMixin.vue'

  export default {
    extends:GuestPageMixin,
    name:"demoTop",
    components: {
    },
    data () {
      return {
      }
    },
    mounted(){
    },
    methods: {
    },
  }
</script>


<style lang="scss" scoped>
  .top-image-area{
  }
  .content-area{
    .operation-btn-area{

    }
    .news-area{
      .news-head{
        position: relative;
        z-index:100;
        margin-top:-1rem;
      }
      .news-head-bg-line{
        position: absolute;
        bottom: 0;
        left: 0;
        background-repeat: no-repeat;
        height:70%;
        background: url("~assets/info_top_frame.png");
        background-size: 100% 100%;
        transform: translateY(0) translateX(0);
      }
      .news-head-bg-line-center{
        position: absolute;
        height:10px;
        left:50%;
        width: 8rem;
        top: 0;
        background-color: #fff;
        transform: translateY(0) translateX(-50%);
        border:none;
      }

      .news-content{
        border:1px solid #ccc;
        /*margin:0 auto;*/
        /*padding:20px 10px;*/
        background-color:#fff;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// DemoTop.vue?2dc87839